// ----------------------------------------------------------------------

export default function rgbaParser(obj) {
  if (typeof obj === 'object')
    return `rgba(${obj.r},${obj.g},${obj.b},${obj.a})`
  else return 'rgba(0,0,0,1)'
}
